import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "account-chip" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "account-chip-name" };
const _hoisted_4 = {
    key: 0,
    class: "account-chip-num"
};
const _hoisted_5 = {
    key: 0,
    class: "summary-row"
};
const _hoisted_6 = { class: "summary-col" };
const _hoisted_7 = { class: "summary-amount" };
const _hoisted_8 = {
    key: 0,
    class: "summary-cr"
};
const _hoisted_9 = { class: "summary-sub" };
const _hoisted_10 = { class: "summary-col summary-col--right" };
const _hoisted_11 = { class: "summary-label" };
const _hoisted_12 = { class: "summary-amount summary-amount--total" };
const _hoisted_13 = {
    key: 0,
    class: "summary-cr"
};
const _hoisted_14 = {
    key: 1,
    class: "summary-row"
};
const _hoisted_15 = { class: "summary-col" };
const _hoisted_16 = { class: "summary-amount" };
const _hoisted_17 = {
    key: 0,
    class: "summary-cr"
};
const _hoisted_18 = { class: "summary-sub" };
const _hoisted_19 = { class: "summary-col summary-col--right summary-col--bottom" };
const _hoisted_20 = { class: "merchant-pill" };
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = { class: "merchant-pill-text" };
import { computed } from 'vue';
import { useTransactionAvatar } from '@/composables/useTransactionAvatar';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionGroupCard',
    props: {
        account: {},
        merchant: {},
        amount: {},
        latestAmount: {},
        date: {},
        rawDate: {},
        count: {},
        formatter: {},
        selected: { type: Boolean },
        transactionId: {},
        description: {},
        tx: {}
    },
    emits: ["view-transactions"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Positive amount = money in (credit); the template adds a small "cr" suffix so it reads differently to spend.
        function fmtAmount(n) {
            return props.formatter.format(Math.abs(n));
        }
        const maskedAccount = computed(() => {
            const n = props.account?.accountNumber;
            return n ? '****' + String(n).slice(-4) : '';
        });
        // Merchant-avatar rule — shared with TransactionsList.
        const { getClassificationIcon, getTransactionLogoUrl, isCategoryIconShown, handleLogoError, getIconStyle } = useTransactionAvatar();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['card', { selected: _ctx.selected }]),
                style: _normalizeStyle('--card-bg: #' + (_ctx.account.bank.hexColour2 ? _ctx.account.bank.hexColour2.substring(2) : '281C3B'))
            }, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-sheen" }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        class: "account-chip-logo",
                        src: _ctx.account.bank.logoPath ? require('@/assets/logos/' + _ctx.account.bank.logoPath) : _ctx.account.bank.logoUri,
                        alt: ""
                    }, null, 8, _hoisted_2),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.account.displayName), 1),
                    (maskedAccount.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(maskedAccount.value), 1))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.count > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "summary-label" }, "Latest", -1)),
                            _createElementVNode("div", _hoisted_7, [
                                _createTextVNode(_toDisplayString(fmtAmount(_ctx.latestAmount)), 1),
                                (_ctx.latestAmount > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "cr"))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.date), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, "Total (" + _toDisplayString(_ctx.count) + ")", 1),
                            _createElementVNode("div", _hoisted_12, [
                                _createTextVNode(_toDisplayString(fmtAmount(_ctx.amount)), 1),
                                (_ctx.amount > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "cr"))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                                class: "view-link",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('view-transactions')))
                            }, "View transactions")
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "summary-label" }, "Amount", -1)),
                            _createElementVNode("div", _hoisted_16, [
                                _createTextVNode(_toDisplayString(fmtAmount(_ctx.amount)), 1),
                                (_ctx.amount > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "cr"))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.date), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("button", {
                                class: "view-link",
                                onClick: _cache[1] || (_cache[1] = ($event) => (emit('view-transactions')))
                            }, "View transaction")
                        ])
                    ])),
                _createElementVNode("div", _hoisted_20, [
                    (_unref(isCategoryIconShown)(_ctx.tx))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "merchant-pill-logo category-icon-wrap",
                            style: _normalizeStyle(_unref(getIconStyle)(_ctx.tx))
                        }, [
                            _createElementVNode("img", {
                                class: "category-icon-img",
                                src: _unref(getClassificationIcon)(_ctx.tx),
                                alt: ""
                            }, null, 8, _hoisted_21)
                        ], 4))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "merchant-pill-logo",
                            src: _unref(getTransactionLogoUrl)(_ctx.tx),
                            style: _normalizeStyle(_unref(getIconStyle)(_ctx.tx)),
                            onError: _cache[2] || (_cache[2] = ($event) => (_unref(handleLogoError)($event, _ctx.tx))),
                            alt: ""
                        }, null, 44, _hoisted_22)),
                    _createElementVNode("span", _hoisted_23, _toDisplayString((_ctx.description || _ctx.merchant).toUpperCase()), 1)
                ])
            ], 6));
        };
    }
});
